import { VesselData, InfoData } from "./data";

export function mapVesselDataFromJson(json) {
  return new VesselData(
    json["Vessel"],
    json["Group"],
    json["idVessel"],
    json["Class"],
    json["IMO"],
    json["Fouling"],
    json["Consumption"],
    json["Date"],
    json["coordinates"],
    json["ME_RPM"],
    json["ME_Power"],
    json["GPS_Speed"],
    json["LOG_Speed"],
    json["avgDraft"],
    json["mcr"],
    json["nmcr"]
  );
}

export function mapInfoDataFromJson(json) {
  return new InfoData(
    json["location"],
    json["description"],
    Boolean(json["visible"])
  );
}
